import { useParams, useSearchParams } from "react-router-dom";
import ApprovalEscalate, { type EscalateTab } from "@/features/approvals/approval-escalate";
import ApprovalMissing from "@/features/approvals/approval-missing";
import { MOCK_APPROVAL_DETAILS } from "@/data/mock";

export default function ApprovalEscalatePage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") ?? undefined;
  const detail = MOCK_APPROVAL_DETAILS.find((d) => d.id.toUpperCase() === id!.toUpperCase());

  if (!detail) return <ApprovalMissing id={id!} />;

  const initialTab: EscalateTab = tab === "hold" || tab === "escalate" ? tab : "reject";

  return <ApprovalEscalate detail={detail} initialTab={initialTab} />;
}
